import React, { useEffect } from 'react';
import styles from './AdditionallyBody.module.scss';
import { Form } from 'antd';
import { docTypes } from '../../constants/documents.constants';
import DispexInput, { typeInput } from '../../../../components/DispexInput';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import DropdownSelect from '../../../../components/dropdownSelect';
import { getDocOptionsSelect } from '../../utils/getDocOptionsSelect';
import { getRenderControl } from '../../../../components/SingleControlCustom/getRenderControl';
import Comments from '../Comments/Comments';

const AdditionallyBody = ({
  form,
  isFetchingComment,
  lastComment,
  statuses,
  isFetchingStatuses,
  topicsData,
  isDocsTopicsFetching,
  appealTopicsData,
  isDocsAppealTopicsFetching,
}) => {
  const { getFieldDecorator, getFieldValue, getFieldError, resetFields } = form;

  const { mode } = useSelector(documentDrawerSelector);

  const docType = getFieldValue('typeId');
  const docTopicIdValue = getFieldValue('topicId');
  const topicValue = getFieldValue('topic');

  const showStatus = mode === 'edit';

  const options = getDocOptionsSelect(statuses);
  const optionsTopic = getDocOptionsSelect(
    docType === docTypes.citizenAppeal ? appealTopicsData : topicsData
  );

  useEffect(() => {
    if (!!docTopicIdValue) {
      resetFields(['topic']);
    }
  }, [resetFields, docTopicIdValue]);

  useEffect(() => {
    if (!!topicValue) {
      resetFields(['topicId']);
    }
  }, [resetFields, topicValue]);

  return (
    <div className={styles.root}>
      <Form.Item label="Тема">
        {getFieldDecorator('topicId', {
          rules: [
            {
              required: !!!topicValue,
              message: `Пожалуйста, укажите тему`,
            },
          ],
        })(
          <DropdownSelect
            multiple={false}
            placeholder="Тема"
            options={optionsTopic}
            renderControl={getRenderControl({
              options: optionsTopic,
              isClear: true,
              value: getFieldValue('topicId'),
              disabled:
                isDocsTopicsFetching ||
                isDocsAppealTopicsFetching ||
                !!topicValue,
              loading: isDocsTopicsFetching || isDocsAppealTopicsFetching,
              onClearClick: () => {
                resetFields(['topicId']);
              },
            })}
          />
        )}
      </Form.Item>

      <Form.Item
        label="Произвольная тема"
        style={{ margin: 0 }}
      >
        {getFieldDecorator('topic', {
          rules: [
            {
              required: !!!docTopicIdValue,
              message: 'Пожалуйста, укажите произвольную тему',
            },
          ],
        })(
          <DispexInput
            typeInput={typeInput.input}
            hasError={getFieldError('topic')?.length > 0}
            className={styles.inputCustom}
            placeholder="Произвольную тему"
            disabled={!!docTopicIdValue}
          />
        )}
      </Form.Item>
      {showStatus && (
        <Form.Item label="Статус">
          {getFieldDecorator('statusId', {
            rules: [
              {
                required: true,
                message: 'Пожалуйста, укажите статус документа',
              },
            ],
          })(
            <DropdownSelect
              disabled={isFetchingStatuses}
              loading={isFetchingStatuses}
              multiple={false}
              placeholder="Статус"
              options={options}
              renderControl={getRenderControl({
                options: options,
                isClear: false,
                value: getFieldValue('statusId'),
                disabled: isFetchingStatuses,
              })}
            />
          )}
        </Form.Item>
      )}
      {mode === 'create' ? (
        <Form.Item
          label="Комментарий"
          style={{ margin: 0 }}
        >
          {getFieldDecorator('note', {
            rules: [
              {
                max: 1024,
                message: 'Комментарий не должен превышать 1024 символа.',
              },
            ],
          })(
            <DispexInput
              typeInput={typeInput.textarea}
              hasError={getFieldError('note')?.length > 0}
              placeholder="Ваш комментарий"
              disabled={isFetchingComment}
            />
          )}
        </Form.Item>
      ) : (
        <Comments />
      )}
    </div>
  );
};

export default AdditionallyBody;
